import { render, staticRenderFns } from "./recuperate.vue?vue&type=template&id=6cf87c64&scoped=true&"
import script from "./recuperate.vue?vue&type=script&lang=ts&"
export * from "./recuperate.vue?vue&type=script&lang=ts&"
import style0 from "./recuperate.vue?vue&type=style&index=0&id=6cf87c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf87c64",
  null
  
)

export default component.exports